import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { isAndroidMobile, isIOS } from './utils/deviceDetection';

if (isIOS()) {
  document.body.classList.add('ios-device');
} else if (isAndroidMobile()) {
  document.body.classList.add('android-mobile');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
